import * as types from './types';
import * as commonTypes from '../common/types';

export default (state = {}, action) => {
    switch (action.type) {
        case commonTypes.ASYNC_START: {
            return {
                ...state,
                loading: true,
                waitting: action.waitting,
                action: commonTypes.ASYNC_START,
            }
        }

        case commonTypes.ASYNC_END: {
            return {
                ...state,
                action: commonTypes.ASYNC_END,
                waitting: commonTypes.ASYNC_END,
                loading: false,
            }
        }
        case types.MY_INVOICE: {
            return {
                ...state,
                action: types.MY_INVOICE,
                invoices: action.status ? action.payload.invoices : { },
                totalRecord: action.status ? action.payload.total : 0,
                totalPage: action.status ? action.payload.total_page : 0,
                status: action.status,
                message: action.message,
            }
        }
        case types.INVOICE_DETAIL: {
            return {
                ...state,
                action: types.INVOICE_DETAIL,
                commissions: action.status ? action.payload.commissions : { },
                status: action.status,
                message: action.message,
            }
        }
        default:
            return state;
    }
}

